import { useAppStore } from "store";
import { observer } from "mobx-react";
import classNames from "classnames";
import Alert from "components/base/alert/alert";
import styles from "./styles.module.scss";
import { NavLink } from "react-router-dom";
import { Routes } from "routes";
import { useEffect } from "react";
import LoadingIndicator from "components/partial/loading-indicator/loading-indicator";

const PlayerFinalScreen = () => {
	const { coursesStore, commonStore } = useAppStore();
	const isCertificatesEnabled: boolean = coursesStore.currentCourse.enableCertificates;

	//* Hidden by Vlad request until certificate generation fix. Uncomment and remove "REMOVE" part when fix was ready.
	// const [certPreviewData, setCertPreviewData] = useState<string | undefined>("");

	useEffect(() => {
		if (isCertificatesEnabled) {
			coursesStore.getCourseCertificate(); /*.then((certBase64) => setCertPreviewData(certBase64));*/
		}
	}, [coursesStore, isCertificatesEnabled]);

	if (!isCertificatesEnabled)
		return (
			<div className={styles.certificate_screen__final_message}>
				You have reached the end of the course. <br />
				Please close this window or utilize the menu at the top of the screen to navigate the platform.
			</div>
		);

	// const handleDownloadPdf = async () => {
	// 	const certUrl = await coursesStore.getCourseCertificatePdfUrl();
	// 	window.open(certUrl, "_blank");
	// };

	// const getPreviewImage = () => {
	// 	if (certPreviewData && certPreviewData.length) {
	// 		return (
	// 			<img
	// 				src={`data:image/png;base64,${certPreviewData}`}
	// 				alt="certificate preview"
	// 				className={styles.certificate_screen__certificate_image}
	// 			/>
	// 		);
	// 	}
	// 	return <></>;
	// };

	return (
		<div className={classNames(styles.certificate_screen)}>
			<Alert eventBus={commonStore.alertEventBus} />
			{/* //! REMOVE -------- */}
			<LoadingIndicator
				loading={coursesStore.isLoading}
				spinnerPosition={"center"}
				backgroundStyle={"white"}
				className={styles.certificate_screen__temp_container}
			>
				<h5 className={styles.certificate_screen__message}>Congratulations!</h5>
				<span className={styles.certificate_screen__temp_text}>
					Your certificate will be available in
					<NavLink to={Routes.MyCertificates} className={styles.certificate_screen__link}>
						My Certificates
					</NavLink>
					soon.
				</span>
			</LoadingIndicator>

			{/* //! ---------- */}
			{/* <div className={styles.certificate_screen__left_container}>
				<h5 className={styles.certificate_screen__message}>Congratulations!</h5>
				<NavLink to={Routes.MyCertificates} className={styles.certificate_screen__link}>
					Go to my Certificates
				</NavLink>
				<Button label="Download certificate" onClick={handleDownloadPdf} />
			</div>

			<LoadingIndicator
				loading={coursesStore.isLoading || !certPreviewData || !certPreviewData.length}
				spinnerPosition={"center"}
				backgroundStyle={"white"}
			>
				<div className={styles.certificate_screen__certificate_preview}>{getPreviewImage()}</div>
			</LoadingIndicator> */}
		</div>
	);
};

export default observer(PlayerFinalScreen);
